import React from "react"
import { EmptyStateStyled } from "./EmptyState.styled"

interface EmptyStateProps {
  title?: string
  message?: string
  icon?: React.ReactNode
  action?: React.ReactNode
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = "No hay datos disponibles",
  message = "No se encontraron registros que coincidan con los criterios de búsqueda actuales.",
  icon,
  action
}) => {
  return (
    <EmptyStateStyled>
      <div className="empty-state-container">
        <div className="empty-state-content">
          {icon && <div className="empty-state-icon">{icon}</div>}
          <h2 className="empty-state-title">{title}</h2>
          <p className="empty-state-message">{message}</p>
          {action && <div className="empty-state-action">{action}</div>}
        </div>
      </div>
    </EmptyStateStyled>
  )
}

export default EmptyState
